exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2km2Ts7o{color:#ec0000;display:block;font-style:italic;font-size:12px;line-height:1.2;margin-top:12px}._2km2Ts7o:empty{display:none}", ""]);

// Exports
exports.locals = {
	"validate": "_2km2Ts7o"
};